import type { IconSvgObject } from './types';

const Tick01Icon: IconSvgObject = [
  ["path", { d: "M5 14C5 14 7 14.5 8.5 17.5C8.5 17.5 14.0588 8.33333 19 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Tick01Icon;
